import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";

export const ProtectedRoute = ({ children, roles }) => {
    const { user, loading } = useAuth();
    const loc = useLocation();
    if (loading) {
        return (
            <div data-testid="auth-loading" className="min-h-screen grid place-items-center text-zinc-500 text-sm tracking-label uppercase">
                Loading…
            </div>
        );
    }
    if (!user) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
    if (roles && !roles.includes(user.user_type)) return <Navigate to="/dashboard" replace />;
    return children;
};

export default ProtectedRoute;
